export const LIB_VERSION = "1.1.0";
